import Vue from 'vue';
import FilePreview from '@jgile/laravel-vue/resources/js/components/FilePreview';
import { mapGetters, mapMutations } from 'vuex';
import BundleCalendar from './partials/bundle-calendar';
import Projection from '../assets/partials/Projection';

Vue.component('update-bundle-details', {
    props: {
        attributes: {
            required: true,
        },
        leadTimes: {
            required: true,
        },
    },

    components: { BundleCalendar, Projection, FilePreview },

    data() {
        return {
            unitsChanged: false,
            changesMade: false,
            loading: false,
            editId: null,
            asset: new SparkForm({
                id: null,
                name: '',
                description: '',
                lead_time_id: null,
                asset_type: 'simple',
                status: 0,
                asset_images: [],
                base_units_available: null,
                base_units_posted: null,
                online_price: null,
                bundle_only: false,
                purchase_total_max_units: null,
                purchase_max_units: null,
                purchase_min_units: null,
                purchase_min_games: null,
                demographics_metrics: null,
                home_games: false,
                road_games: false,
                season_long: false,
                year_long: false,
                start_date: null,
                end_date: null,
                products: null,
                industries: [],
                diversity_types: [],
                themes: [],
            }),
            assetState: {},
            leadTime: null,
            previewMedia: null,
            selectedPreview: null,
            previewImage: null,
            datePickerConfig: {
                minDate: new Date(),
                mode: 'range',
            },
        };
    },

    created() {
        const _this = this;

        //
        // Get asset attributes
        //
        let assetAttributes = _.merge(this.attributes, {
            industries: _.map(this.attributes.industries, (industry) => industry.id),
        });

        //
        // Get bundled assets
        //
        this.setAssets(_.get(assetAttributes, 'bundle_assets'));
        this.setInitialAsset(assetAttributes);

        //
        // Get only the asset attributes I need, or default value.
        //
        _.each(this.asset, (value, attribute) => {
            _.set(_this.asset, attribute, _.get(_this.attributes, attribute, value));
            _.set(_this.assetState, attribute, _.get(_this.attributes, attribute, value));
        });

        //
        // Prevent from leaving page with unsaved attributes
        //
        window.onbeforeunload = function(e) {
            if (_this.changesMade) {
                return 'Please save all changes to your bundle page before refreshing the page.';
            }
        };

        //
        // Listen for image preview events
        //
        Bus.$on('mediaLibraryPreviewRowClicked', this.setPreview);

        //
        // Start watching after all is loaded
        //
        this.$nextTick(function() {
            this.$watch('asset', this.watchAsset, {
                immediate: true,
                deep: true,
            });
            this.$watch('asset.lead_time_id', this.watchLeadTime, {
                immediate: true,
                deep: true,
            });
        });

        _.has(this.asset, 'asset_images.0') && Vue.set(this, 'previewMedia', _.get(this.asset, 'asset_images.0'));
    },

    beforeDestroy() {
        Bus.$off('mediaLibraryPreviewRowClicked', this.setPreview);
    },

    computed: {
        ...mapGetters('bundle', ['products', 'allProducts', 'getEvents', 'bundleAssets', 'bundleAssetsCount', 'suggestedPrice']),
    },

    methods: {
        ...mapMutations('bundle', ['setAssets', 'setInitialAsset', 'removeAsset', 'setAssetUnits']),

        /**
         *
         * @param payload
         */
        setPreview(payload) {
            Vue.set(this, 'previewMedia', null);
            this.$nextTick(function() {
                Vue.set(this, 'previewMedia', payload);
            });
        },

        /**
         *
         * @param units
         */
        setUnits(units) {
            this.unitsChanged = true;
            this.setAssetUnits({ asset_id: this.editId, units: units });
            this.updateSuggestedPrice();
            this.$refs.bundleCalendar.refetchEvents();
        },

        /**
         *
         * @param id
         */
        removeAndRefresh(id) {
            this.removeAsset(id);
            this.updateSuggestedPrice();
            this.$refs.bundleCalendar.refetchEvents();
        },

        /**
         *
         */
        saveAndPost() {
            this.asset.status = 1;
            this.save();
        },

        /**
         *
         */
        saveAndStay() {
            this.asset.status = 0;
            this.save();
        },

        /**
         *
         */
        save() {
            const _this = this;
            this.$messenger.loading();

            //
            // Required bundle assets fields
            //
            this.asset.bundle_assets = _.map(this.bundleAssets, function(o) {
                return { asset_id: o.id, units: _.get(o, 'pivot.units', 1) };
            });

            // Bus.$on('messengerMessagesComplete', _this.afterSave);
            Spark.put(`/api/team/bundles/${this.attributes.id}`, this.asset)
                .then((response) => {
                    Vue.set(this.asset, 'artwork', response.data.artwork);
                    Vue.set(this.asset, 'asset_images', response.data.asset_images);
                    Vue.set(this.asset, 'creative_specs', response.data.creative_specs);
                })
                .catch(() => {
                    _this.$nextTick(function() {
                        if ($('.invalid-feedback.d-block').length) {
                            $('html, body').animate(
                                {
                                    scrollTop: $('.invalid-feedback.d-block:first').offset().top - 100,
                                },
                                500,
                            );
                        }
                    });
                })
                .finally(() => {
                    this.$messenger.loaded();

                    _.each(_this.asset, (value, attribute) => {
                        _.set(_this.assetState, attribute, value);
                    });

                    _this.changesMade = false;
                });
        },
        afterSave() {
            const _this = this;

            if (_.toInteger(_this.asset.status) === 1) {
                let queue = [];
                swal({
                    title: 'Completed',
                    type: 'success',
                    showCancelButton: true,
                    confirmButtonText: 'Preview & Post',
                    cancelButtonText: 'Go back to Inventory Manager',
                    confirmButtonClass: 'btn btn-danger mr-2',
                    cancelButtonClass: 'btn btn-cancel',
                    buttonsStyling: false,
                    html: '<strong>This asset is not yet posted!</strong><br>Go to "Preview and Post" to finish posting this asset.',
                }).then((response) => {
                    if (response.dismiss === 'cancel') {
                        window.location = '/team/inventory';
                    } else {
                        window.location = '/team/inventory/preview';
                    }
                });
            }

            Bus.$off('messengerMessagesComplete', _this.afterSave);
        },
        watchLeadTime(newVal) {
            this.leadTime = _.defaultTo(
                _.find(this.leadTimes, (lt) => {
                    return _.toInteger(lt.id) === _.toInteger(newVal);
                }),
                this.leadTimes[0],
            );
        },
        watchAsset(newVal) {
            const _this = this;
            let changes = false;
            _.forEach(newVal, (val, key) => {
                if (val !== _.get(_this.assetState, key)) {
                    changes = true;
                }
            });

            this.changesMade = changes;
        },
        updateSuggestedPrice() {
            Bus.$emit('updatePromoSuggestedPrice', {
                dates: { start_date: this.asset.start_date, end_date: this.asset.end_date },
                assets: _.map(this.bundleAssets, function(o) {
                    return { asset_id: o.id, units: _.get(o, 'pivot.units', 1) };
                }),
            });
        },
    },

    watch: {
        'asset.start_date': {
            deep: true,
            handler(newVal) {
                this.updateSuggestedPrice();
            },
        },
        'asset.end_date': {
            deep: true,
            handler(newVal) {
                this.updateSuggestedPrice();
            },
        },
        'asset.asset_images': {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (Array.isArray(newVal) && newVal.length === 0) {
                    Vue.set(this, 'previewMedia', null);
                }

                if (!this.previewMedia) {
                    _.has(newVal, '0') && Vue.set(this, 'previewMedia', _.get(newVal, '0'));
                }
            },
        },
        suggestedPrice() {
            if (this.asset.online_price === 0) {
                this.asset.online_price = this.attributes.online_price > 0 ? this.attributes.online_price : this.suggestedPrice;
            }
        },

        bundleAssets: {
            immediate: true,
            handler(newVal) {
                this.editId = _.get(newVal, '0.id', null);
                this.updateSuggestedPrice();
            },
        },
    },
});
